import { render, staticRenderFns } from "./PedidosPendente.vue?vue&type=template&id=035d9e1c"
import script from "./PedidosPendente.vue?vue&type=script&lang=js"
export * from "./PedidosPendente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports